import React from "react";
import {
  Card,
  List,
  ListItem,
  Typography,
} from "@material-tailwind/react";
import { downloadFiles } from "../constants/DownloadFiles";

const Downloads = () => {
  return (
    <div className="w-80 mx-auto my-4">
      <h3 className="text-center font-bold text-xl text-white bg-blue-400 w-80">
        Downloads
      </h3>
      <marquee direction="up" className="bg-gray-100 h-80">
        <Card className="flex-col bg-white">
          <List>
            {downloadFiles.map((item, index) => (
              <ListItem key={index}>
                <div>
                  <Typography variant="h6" color="blue-gray">
                    <a
                      href={item.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline text-blue-600"
                    >
                      {item.name}
                    </a>
                  </Typography>
                </div>
              </ListItem>
            ))}
          </List>
        </Card>
      </marquee>
    </div>
  );
};

export default Downloads;
